import {FC, forwardRef, HTMLProps, Ref} from 'react'

import {CloseCircleIcon} from '@/components/common/icons/CloseCircleIcon'
import {SearchIcon} from '@/components/common/icons/SearchIcon'
import {Input} from '@/components/inputs/Input'
import {theme} from '@/theme/theme'

type SearchInputProps = {
  query: string
  setQuery: (query: string) => void
  setIsSearchFocused?: (isFocused: boolean) => void
  placeholder?: string
  hasBorder?: boolean
  ref?: Ref<HTMLInputElement>
  color?: string
  backgroundColor?: string
  borderColor?: string
} & HTMLProps<HTMLInputElement>

export const SearchInput: FC<SearchInputProps> = forwardRef(
  (
    {
      query,
      setQuery,
      setIsSearchFocused,
      placeholder,
      hasBorder,
      color,
      backgroundColor,
      borderColor,
    },
    ref,
  ) => (
    <>
      <div className="search">
        <div className="search-icon">
          <SearchIcon color={color ?? theme.palette.gray[400]} />
        </div>
        <Input
          ref={ref}
          id="search-service"
          value={query}
          onChange={(e) => setQuery((e.target as HTMLInputElement).value)}
          placeholder={placeholder}
          onFocus={() => setIsSearchFocused && setIsSearchFocused(true)}
          onBlur={() => setIsSearchFocused && setIsSearchFocused(false)}
          autoComplete="off"
          onKeyPress={(e) => e.key === 'Enter' && e.preventDefault()}
          hasStartIcon
          hasEndIcon
          hasBorder={hasBorder}
          color={color}
          backgroundColor={backgroundColor}
          borderColor={borderColor}
        />
        {query && (
          <button type="button" className="clear-button" onClick={() => setQuery('')}>
            <CloseCircleIcon
              backgroundColor={theme.palette.gray[600]}
              iconColor={theme.palette.text.white}
            />
          </button>
        )}
      </div>

      <style jsx>{`
        .search {
          position: relative;
          display: flex;
          align-items: center;
        }
        .search-icon {
          display: flex;
          position: absolute;
          left: 8px;
        }
        .clear-button {
          display: flex;
          position: absolute;
          right: 8px;
          padding: ${theme.spacing[0.5]};
          margin: -${theme.spacing[0.5]};
        }
      `}</style>
    </>
  ),
)
